import { z } from 'zod';
import { PROVIDER_KINDS, Province } from './enums.js';
import { Cuid2 } from './primitives.js';
/** A suburb or town members can pick (D24). Only active areas are listed. */
export const AreaDto = z.object({
    id: Cuid2,
    name: z.string(),
    city: z.string(),
    province: Province,
});
/** `GET /catalog/areas`, sorted by name. */
export const AreaListDto = z.object({ areas: z.array(AreaDto) });
/** A trade category. Its kind matches the kind of provider who can choose it. */
export const CategoryDto = z.object({
    id: Cuid2,
    slug: z.string(),
    name: z.string(),
    kind: z.enum(PROVIDER_KINDS),
});
/** `GET /catalog/categories`: active categories, in display order. */
export const CategoryListDto = z.object({ categories: z.array(CategoryDto) });
//# sourceMappingURL=catalog.js.map